module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ksm-deepzoom__page-wrapper ksm-flex-column"
  }, [_c('div', {
    staticClass: "ksm-fabricview__toolbar"
  }, [(_vm.showColorPicker) ? _c('photoshop-picker', {
    staticStyle: {
      "position": "absolute",
      "z-index": "100"
    },
    on: {
      "ok": _vm.actionOk,
      "cancel": _vm.actionCancel,
      "input": _vm.changeBackgroundColor
    },
    model: {
      value: (_vm.backgroundColor),
      callback: function($$v) {
        _vm.backgroundColor = $$v
      },
      expression: "backgroundColor"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    ref: "osdButtonsDiv",
    staticClass: "ksm-disable-select osdButtonsDiv"
  }), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": ".json",
      "id": "loadSetup"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "ksm-flex"
  }, [_c('div', {
    staticClass: "ksm-fabricview__btn",
    attrs: {
      "title": "Komposition neu"
    },
    on: {
      "click": _vm.resetCanvas
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.$_getSvg('komposition-neu.svg'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ksm-fabricview__btn",
    attrs: {
      "title": "Komposition öffnen"
    },
    on: {
      "click": _vm.openFilemanager
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.$_getSvg('konfiguration_oeffnen.svg'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ksm-fabricview__btn",
    attrs: {
      "title": "Komposition speichern"
    },
    on: {
      "click": _vm.speichern
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.$_getSvg('konfiguration_speichern.svg'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ksm-fabricview__btn",
    attrs: {
      "title": "Komposition exportieren"
    },
    on: {
      "click": _vm.exportieren
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.$_getSvg('komposition-exportieren.svg'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ksm-fabricview__btn",
    attrs: {
      "title": "löschen"
    },
    on: {
      "click": _vm.removeObject
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.$_getSvg('komposition-loeschen.svg'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ksm-fabricview__btn",
    attrs: {
      "title": "in den vordergrund"
    },
    on: {
      "click": _vm.vordergrundObject
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.$_getSvg('ebene-tiefer.svg'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ksm-fabricview__btn",
    attrs: {
      "title": "in den hintergrund"
    },
    on: {
      "click": _vm.hintergrundObject
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.$_getSvg('ebene-hoeher.svg'))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "ksm-fabricview__btn",
    on: {
      "click": function($event) {
        _vm.showColorPicker = true
      }
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.$_getSvg('farbe-waehlen.svg'))
    }
  })])])], 1), _vm._v(" "), _c('div', {
    staticClass: "ksm-deepzoom__page ksm-flex-1",
    style: ('background-color:' + _vm.backgroundColor)
  }, [_c('div', {
    staticClass: "ksm-position-absolute ksm-flex"
  }, [_c('div', {
    staticClass: "ksm-deepzoom__body",
    attrs: {
      "id": _vm.containerId
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    ref: "infobox_template",
    staticClass: "ksm-gummi__end-overlay",
    class: _vm.modusOption.key
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "__body"
  })]), _vm._v(" "), _c('div', {
    ref: "popup-menu_template",
    staticClass: "ksm-deepzoom__popupmenu-overlay"
  }, [_vm._m(1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "__head ksm-flex"
  }, [_c('div', {
    staticClass: "__title ksm-flex-1 ksm-flex"
  }), _vm._v(" "), _c('div', {
    staticClass: "__close-infobox"
  }, [_vm._v("x")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ksm-flex"
  }, [_c('div', {
    staticClass: "ksm-deepzoom__popupmenu__color-rect"
  }), _vm._v(" "), _c('div', {
    staticClass: "ksm-deepzoom__popup-menuitem"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-640f0ec2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FabricView.vue
// module id = 1977
// module chunks = 1